import { QueryClient } from "@tanstack/react-query";
import { toast } from "@/stores/toastStore";
import { onSessionChange, SessionChangedError } from "./sessionLifecycle";
import { errorMessage } from "@/utils/errors";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error: unknown) => {
        if (error instanceof SessionChangedError) return;
        toast.error(errorMessage(error));
      },
    },
  },
});

onSessionChange(() => {
  void queryClient.cancelQueries();
  queryClient.clear();
});
